type LogLevel = 'info' | 'warn' | 'error';

function print(level: LogLevel, message: string, detail?: unknown) {
  // 生产环境不打 info，避免圈选/定位正常路径刷屏
  if (level === 'info' && process.env.NODE_ENV !== 'development') {
    return;
  }

  const prefix = '[visual-tracking] ' + message;

  if (detail === undefined) {
    console[level](prefix);
    return;
  }

  console[level](prefix, detail);
}

export const logger = {
  info(message: string, detail?: unknown) {
    print('info', message, detail);
  },
  warn(message: string, detail?: unknown) {
    print('warn', message, detail);
  },
  error(message: string, detail?: unknown) {
    print('error', message, detail);
  },
};
